import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import useCountryCode from 'hooks/useCountryCode';
import IntlTelInput from 'react-intl-tel-input';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles.module.scss';
import 'react-intl-tel-input/dist/main.css';

const {
  strings: { THERE_WAS_A_PROBLEM_SENDING_THE_TEXT, PLEASE_CHECK_THE_NUMBER_AND_TRY_AGAIN }
} = StringConstantsMixin;

function Phone({ classes, error, onChange }) {
  const countryCode = useCountryCode();

  return (
    <>
      <IntlTelInput
        containerClassName={classNames('intl-tel-input', classes)}
        preferredCountries={[countryCode]}
        inputClassName={styles.phone}
        onPhoneNumberChange={onChange}
      />
      {error && (
        <span className={styles.error}>
          {THERE_WAS_A_PROBLEM_SENDING_THE_TEXT}
          <br />
          {PLEASE_CHECK_THE_NUMBER_AND_TRY_AGAIN}
        </span>
      )}
    </>
  );
}

Phone.defaultProps = {
  classes: undefined,
  error: false
};

Phone.propTypes = {
  classes: PropTypes.string,
  error: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export default Phone;
